import React, { useState, useEffect } from 'react'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import { getDatasetFiles } from '../../../services/endpoints'
import ICSDataGrid from '../../../components/ICSDataGrid/ICSDataGrid'
import { getFileSize } from '../../../utils/helpers'
import { useTimezone } from '../../../hooks/useTimezone'
function DataSetReview(props) {
  const [data, setData] = useState<any>([])
  const { formatLocalTimeFromUtc } = useTimezone()
  useEffect(() => {
    const init = async () => {
      const files: any = await getDatasetFiles(props.datasetId)
      files.map(file => {
        file.name = file.filepath.split('/').pop()
        file.readableSize = getFileSize(file.size)
        return file
      })
      setData(files)
    }
    init()
  }, [props.datasetId])
  return (
    <ICSDataGrid
      dataSource={data}
      options={{showScrollbar: 'always'}}
      columnOptions={[
        { dataField: 'data.uploadId', caption: 'Upload ID' },
        { dataField: 'name', caption: 'Name' },
        { dataField: 'data.vehicle', caption: 'Vehicle' },
        { dataField: 'readableSize', caption: 'Size' },
        {
          dataField: 'last_modified',
          caption: 'Last Modified',
          cellRender: (cell) => formatLocalTimeFromUtc(cell.value) ?? ''
        },
      ]}
    />
  )
}
export default DataSetReview
